module.exports = __webpack_public_path__ + "documents/kyle+resume_2019-07-19-b740fcd47e8f22368fb568c1431f2969.pdf";